module.exports = __webpack_public_path__ + "static/media/documents.7b05b158.svg";